import { useTracking } from 'react-tracking';

import {
  Alert,
  AlertAction,
  Box,
  Button,
  Grid,
  Heading,
  Text,
} from '@simplywallst/ui-core';
import { Header } from '@components/ActionSheet';

import { ValuationOptionBuildMyNarrative } from '../ValuationOptionBuildMyNarrative';

import { useValuationSelectionFormData } from './hooks/useValuationSelectionFormData';
import { NarrativesEmptyPanel } from '../NarrativesEmptyPanel';

export interface Props {
  companyId: string;
  onClose: () => void;
  openOnboardingFlow: () => void;
  userHoldsPosition?: boolean;
}

export const ValuationSelectionForm = ({
  companyId,
  onClose,
  openOnboardingFlow,
  userHoldsPosition,
}: Props) => {
  const { Track } = useTracking();

  const { isNarrativeOnboardingComplete, tickerSymbol, myNarrative } =
    useValuationSelectionFormData({
      companyId,
    });

  const error = false; // TODO handle select valuation errors
  const dismissError = () => {}; // TODO handle select valuation error dismiss

  return (
    <Track>
      <Header>
        <Text typography="baseStrong" color="textSolid">
          Valuation for {tickerSymbol}
        </Text>
      </Header>

      <Box position="relative">
        {error && (
          <Box position="absolute" top="0" left="0" right="0" zIndex="1">
            <Grid paddingXMd="x4" paddingX="x2" paddingTop="x3">
              <Alert
                styleType="negative"
                actions={
                  <AlertAction shouldDismissAlert onClick={dismissError}>
                    OK
                  </AlertAction>
                }
              >
                Failed to select fair value. Please try again.
              </Alert>
            </Grid>
          </Box>
        )}

        <Grid templateRows="1fr max-content" height="100%">
          <Grid
            paddingXMd="x4"
            paddingX="x2"
            paddingTop="x3"
            rowGap="16px"
            autoRows="max-content"
          >
            {!myNarrative && (
              <ValuationOptionBuildMyNarrative
                companyId={companyId}
                isNarrativeOnboardingComplete={isNarrativeOnboardingComplete}
                openOnboardingFlow={openOnboardingFlow}
                userHoldsPosition={userHoldsPosition}
              />
            )}

            <Heading as="h3" color="textSoft" typography="xSmall">
              Community Narratives
            </Heading>
            <NarrativesEmptyPanel />
          </Grid>

          <Grid
            templateColumns="max-content"
            paddingRight="x4"
            paddingY="x2"
            justifyContent="end"
          >
            <Button
              styleType="louderLarge"
              onClick={onClose}
              data-cy-id="narrative-fair-value-modal-done"
            >
              Done
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Track>
  );
};
